
export const getters = {
    userRoles: state => state.userroles,
    userRoleModules: state => state.rolemodules,
    rolemModulePermissions: state => state.modulePermissions,
    moduleId: state => state.moduleId
}

export default getters


// WEBPACK FOOTER //
// ./src/vuex/modules/userroles/getters.js